import React, { useState } from "react";
import "./Menu.css";

function Menu() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* BOTÓN */}
      <div className="burger" onClick={() => setOpen(true)}>
        ☰
      </div>

      {/* OVERLAY */}
      <div className={`menu-overlay ${open ? "open" : ""}`}>
        <div className="menu-content">
          <span className="close" onClick={() => setOpen(false)}>×</span>

          <ul>
            <li><a href="/">Inicio</a></li>
            <li><a href="/desarrollo-web">Desarrollo Web</a></li>
            <li><a href="/ecommerce">E-commerce</a></li>
            <li><a href="/contacto">Contacto</a></li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Menu;